(function () {
  function egGetPickerRankingConfig(handle) {
    var cfg = window.EG_COLLECTION_PICKER_RANKING || {};
    var byHandle = cfg.handles || {};
    return handle && byHandle[handle] ? byHandle[handle] : null;
  }

  function egReadPickerSoftStateFromUrl() {
    var sp = new URLSearchParams(window.location.search || "");

    return {
      movement_space: String(sp.get("eg_pick_move") || "").replace(/^\s+|\s+$/g, ""),
      secondary_priority: String(sp.get("eg_pick_priority") || "").replace(/^\s+|\s+$/g, "")
    };
  }

  function egHasActivePickerSoftState(state) {
    if (!state) return false;
    return !!(state.movement_space || state.secondary_priority);
  }

  function egGetPickerProductScore(product, handle) {
    var cfg = egGetPickerRankingConfig(handle);
    if (!cfg || typeof cfg.score !== "function") return 0;

    var state = egReadPickerSoftStateFromUrl();
    if (!egHasActivePickerSoftState(state)) return 0;

    try {
      return parseFloat(cfg.score(product, state)) || 0;
    } catch (e) {
      return 0;
    }
  }

  function egSortProductsByPickerScore(arr, handle) {
    if (!arr || arr.length < 2) return arr;

    var cfg = egGetPickerRankingConfig(handle);
    if (!cfg || typeof cfg.score !== "function") return arr;

    var state = egReadPickerSoftStateFromUrl();
    if (!egHasActivePickerSoftState(state)) return arr;

    var out = arr.slice(0);

    out.sort(function (a, b) {
      var sa = 0;
      var sb = 0;

      try { sa = parseFloat(cfg.score(a, state)) || 0; } catch (e1) {}
      try { sb = parseFloat(cfg.score(b, state)) || 0; } catch (e2) {}

      if (sa !== sb) return sb - sa;

      var ta = String((a && a.title) || "").toLowerCase();
      var tb = String((b && b.title) || "").toLowerCase();

      if (ta < tb) return -1;
      if (ta > tb) return 1;
      return 0;
    });

    return out;
  }

  window.egGetPickerRankingConfig = egGetPickerRankingConfig;
  window.egReadPickerSoftStateFromUrl = egReadPickerSoftStateFromUrl;
  window.egGetPickerProductScore = egGetPickerProductScore;
  window.egSortProductsByPickerScore = egSortProductsByPickerScore;
})();